module.exports = __webpack_public_path__ + "static/laptops-0d223f6040dc1f19a78ea6201ca4806c.svg";